const isProduction = window.location.hostname !== 'localhost' &&
  window.location.hostname !== '127.0.0.1';

export const API_BASE_URL = isProduction
  ? 'https://sapi-dz.org'
  : 'http://localhost:5000';

export const API_URL = `${API_BASE_URL}/api`;
